<template>
  <div v-if="camposVisiveis.length > 0" class="ficha-tecnica">
    <h6 class="ficha-title font-small-3">FICHA TÉCNICA</h6>
    <div class="ficha-grid">
      <div
        v-for="campo in camposVisiveis"
        :key="campo.label"
        class="ficha-item"
      >
        <span class="ficha-label text-muted">{{ campo.label }}</span>
        <span class="ficha-value">{{ campo.valor }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import SLSItemService from '@/services/SistemaDKP/SLSItem.service';

export default {
  name: 'ItemFichaTecnica',
  props: {
    itemId: {
      type: [String, Number],
      required: false,
      default: null,
    },
  },
  data() {
    return {
      item: null,
    };
  },
  computed: {
    camposVisiveis() {
      const i = this.item;
      if (!i) return [];
      const campos = [
        { label: 'Idioma', valor: i.cod_idioma || i.lingua },
        { label: 'Coleção', valor: i.colecao },
        { label: 'Componente', valor: i.componente },
        { label: 'Nível educacional', valor: i.niveleducacional },
        { label: 'Segmento', valor: i.segmento },
        { label: 'Páginas', valor: i.qtdpaginas > 0 ? i.qtdpaginas : null },
        { label: 'Ano de lançamento', valor: i.anolancamento },
      ];
      return campos.filter((c) => c.valor !== null && c.valor !== undefined && String(c.valor).trim() !== '');
    },
  },
  watch: {
    itemId: {
      immediate: true,
      handler(novo) {
        this.item = null;
        if (novo) this.carregarItem(novo);
      },
    },
  },
  methods: {
    async carregarItem(itemId) {
      try {
        const service = new SLSItemService();
        const resp = await service.getItemById(itemId);
        // O client retorna a resposta axios completa; o item vem em resp.data.
        const data = resp && resp.data;
        // Guarda apenas se ainda for o item solicitado (evita corrida em troca rápida).
        if (String(this.itemId) === String(itemId)) {
          this.item = data && data.item_id ? data : null;
        }
      } catch (e) {
        console.error('[ItemFichaTecnica] Erro ao carregar ficha do item:', e);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.ficha-tecnica {
  margin-top: 0.75rem;

  .ficha-title {
    font-weight: 600;
    letter-spacing: 0.06em;
    margin-bottom: 6px;
    color: inherit;
  }
}

.ficha-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(170px, 1fr));
  gap: 4px 16px;
}

.ficha-item {
  display: flex;
  flex-direction: column;
  line-height: 1.3;

  .ficha-label {
    font-size: 0.72rem;
    text-transform: uppercase;
    letter-spacing: 0.03em;
  }

  .ficha-value {
    font-size: 0.85rem;
    font-weight: 500;
  }
}
</style>
